import { render, staticRenderFns } from "./Сomments.vue?vue&type=template&id=c11f0c48&"
import script from "./Сomments.vue?vue&type=script&lang=js&"
export * from "./Сomments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports